<template>
  <div>
    <el-popover ref="popover" title="" :disabled="showTool" :content="contentInfo" width="auto" effect="dark" trigger="click" popper-class="g-long-popper" 
      placement="bottom">
      <div slot="reference" class="contentWidth" :style="{cursor: showTool ? 'auto' : 'pointer'}">
        <span ref="contentInfo">{{contentInfo}}</span>
      </div>
    </el-popover>
  </div>
</template>


<script>
export default {
  props: {
    contentInfo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showTool: false
    }
  },
  watch: {
    contentInfo: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          if (val) {
            const tag = this.$refs.contentInfo
            if (!tag) return false
            const parentWidth = tag.parentNode.offsetWidth // 获取元素父级可视宽度
            // const parentHeight = tag.parentNode.offsetHeight // 获取元素父级可视宽度
            const contentWidth = tag.offsetWidth // 获取元素可视宽度
            // const contentHeight = tag.offsetHeight // 获取元素可视宽度
            console.log(parentWidth, contentWidth)
            this.showTool = contentWidth <= parentWidth
            // this.showTool = contentHeight <= parentHeight
          } else {
            this.showTool = false
          }
          // this.$nextTick(() => {if (this.$refs.popover) {this.$refs.popover.updatePopper();}})
        })
      }
    }
  },
  methods: {

  }
}
</script>

<style>
  .g-long-popper.el-popover {
    max-width: 400px;
  }
  /* @media (max-width:1700px) {
    .g-long-popper.el-popover {
      margin-top: calc(100vh - 100%)
    }
  } */
</style>
<style scoped lang="scss">
.contentWidth {
  max-width: 100%;
  // line-height: 22px;
  // max-height: 66px;
  // -webkit-line-clamp: 3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // display: -webkit-box;
  // -webkit-box-orient: vertical;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/tooltipRow1.vue